import { useQuery } from "@tanstack/react-query";
import MiniWidgets from "../../../MiniWidgets";
import { useMemo } from "react";
import DashboardService from "src/apis/DashboardService";
import { toast } from "react-toastify";
import { withNamespaces } from "react-i18next";

const DashboardTotalCases = ({ t, filters, modules }) => {
  const { data: dashboardData, isFetching: summaryIsFetching } = useQuery({
    queryKey: ["wb-cm-fetch-admin-dashboard-summary-query", filters],
    queryFn: async () => {
      const service = DashboardService.getInstance();
      return await service.fetchSummary(
        {
          ...filters,
          excludeDeleted: (filters.exclude || []).includes("deleted_cases"),
          excludeTestCases: (filters.exclude || []).includes("test_cases"),
          exclude: undefined,
        },
        modules?.active
      );
    },
    cacheTime: 0,
    refetchOnWindowFocus: false,
    onError: (error) => {
      if (process.env.NODE_ENV === "development") console.error(error);

      toast(t("An error occurred while fetching dashboard data."), {
        type: "error",
      });
    },
  });

  const totalCases = useMemo(() => {
    const result = [];
    if (dashboardData?.totalCases) {
      result.push({
        amount: dashboardData.totalCases,
        percent: 100,
        title: "Total",
        icon: "ri-stack-line",
        displayChart: false,
      });

      const statuses = dashboardData?.statuses || {};

      for (const item in statuses) {
        let title = "";
        if (statuses[item].title === "closed") {
          title = "closed";
        } else if (statuses[item].title === "in progress") {
          title = "In Progress";
        } else if (statuses[item].title === "new") {
          title = "New";
        } else if (statuses[item].title === "pending deletion") {
          title = "Pending Deletion";
        } else {
          title = statuses[item].title;
        }

        result.push({
          amount: statuses[item].amount,
          percent: statuses[item].percent,
          title: t(title),
          icon: null,
          displayChart: true,
        });
      }
    }

    return result;
  }, [dashboardData?.totalCases, dashboardData?.statuses, t]);

  return  <MiniWidgets reports={totalCases} isLoading={summaryIsFetching } />
};

export default withNamespaces()(DashboardTotalCases);
